import { parse } from 'querystring';
import { filter, isArray, map } from 'lodash';

export const getCreativeImagesFromParams = () => {
  const query = parse(location.search);

  if (!query.images) return;

  if (typeof query.images === 'string') {
    return [query.images.split('-')[0]];
  }

  if (isArray(query.images)) {
    const creativeImages = filter(query.images, (image) => image.split('-')[1] === 'CreativeImage');
    return map(creativeImages, (img) => img.split('-')[0]);
  }

  return null;
};
